export const magic = {
  accessToken: 'accessToken',
};
